import { Col, ColProps } from '@components/Layout/Col';
import { createMemo } from '@packages/react';
import React from 'react';

export const SummaryItemHolder = createMemo<ColProps>(
    (props) => <Col xs={12} sm={6} md={4} lg={3} padding={8} {...props} />,
    { displayName: 'SummaryItemHolder' },
);
